import axios from 'axios';
import Http from './http';
import { GeoHash } from 'geohash';

const GOOGLE_API_KEY = 'AIzaSyAwDSvCoCt2r6cTpaBxKJIrZvG-NCEGqTE';

export const generateGeoHash = ({lat, lng}) => GeoHash.encodeGeoHash(lat, lng);

export const fetchLocationByCep = ({cep}) => axios.get(`https://viacep.com.br/ws/${cep}/json/`);

export const testAPIConnection = ({apiData, storeId}) => Http.post('testVarejoFacilConnection', {apiData, storeId});

export const geocodeAddress = ({zipcode, address, number, district, state}) => {
  let stringAddress = `${zipcode}, ${address}`;
  if(number) stringAddress += `, ${number}`;
  stringAddress += `, ${district}, ${state}`;
  return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${stringAddress}&key=${GOOGLE_API_KEY}`);
};